var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":"https://apexcharts.com/vue-chart-demos/radar-charts/basic/","target":"_blank"}},[_vm._v("Radar")])
}
var staticRenderFns = []

export { render, staticRenderFns }